import { render, staticRenderFns } from "./Extension.vue?vue&type=template&id=255c16d2&scoped=true&"
import script from "./Extension.vue?vue&type=script&lang=js&"
export * from "./Extension.vue?vue&type=script&lang=js&"
import style0 from "./Extension.vue?vue&type=style&index=0&id=255c16d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255c16d2",
  null
  
)

export default component.exports